module.exports = __webpack_public_path__ + "static/img/content7.282bf831.png";